import { IPanelLink } from '../../models/dataset/DatasetRelated';
import TGeneralUserConfig from '../../models/user-config/GeneralUserConfig';
import { AppState } from '../reducers/root';

export const getPanelLinksConfig = (state: AppState): IPanelLink[] =>
  state.userConfig.panelLinks;

export const getGeneralConfig = (state: AppState): TGeneralUserConfig =>
  state.userConfig.general;

export const getPresetColors = (state: AppState): string[] | undefined =>
  state.userConfig.general.presetColors;

export const getDatasetSearchContains = (state: AppState): boolean =>
  state.userConfig.general.datasetSearchContains ?? false;

export const getDatasetSearchCaseSensitive = (state: AppState): boolean =>
  state.userConfig.general.datasetSearchCaseSensitive ?? false;
